<template>
  <modal titulo="Imprimir" id="modal-imprimir">

    <card>
      <card-content>

        <div class="row no-gutters w-100">

          <v-input type="select" :options="layouts" label="Layout" v-model="form.layout" class="col px-1" />
          <v-input type="select" :options="dpiDigitalizacao" label="Qualidade das imagens"
                   v-model="form.dpiDigitalizacao" class="col-auto px-1" >
            <template #label>
              <a href class="icon" @click.prevent="exibirAjuda(textosAjuda.dpiDigitalizacao)" tabindex="-1">
                <i class="fal fa-question-circle pointer ml-2 small" title="Texto de Ajuda"></i>
              </a>
            </template>
          </v-input>

          <v-input label="Livro" v-model="form.livro" type="text" class="col-4 px-1" />
          <div class="w-100" />

          <v-input :defaut="false" label="Incluir texto externo? (Matrículas importadas com texto externo)"
                   v-model="form.incluirTextoLegado" type="radio" class="col px-1" />

<!--          <div class="w-100"></div>-->

<!--          <v-input label="Incluir linhas de Encerramento?" v-model="form.linhaEncerramento" type="radio" class="col" />-->

<!--          <template v-if="form.linhaEncerramento">-->
<!--            <v-input type="number" label="Quantidade de Linhas" class="col" v-model="form.quantidadeLinha" />-->
<!--          </template>-->
        </div>

        <card-table class="mt-1 mb-3">
          <tbody>
            <tr v-for="(ficha, i) in fichas" :key="`${ficha.livro}-${ficha.id}`">
              <td>
                {{nomearFicha(ficha)}}
              </td>
              <td width="30px">
                <a @click.prevent="removerFichas(i)" class="icon">
                  <i class="fa fa-times"></i>
                </a>
              </td>
            </tr>
            <tr>
              <td colspan="100%">
                <buscar-fichas :limparCampo="true" :livro="livro"
                               status="ABERTA" ref="buscarFichas" @selecionar="selecionarFichas" />
              </td>
            </tr>
          </tbody>

        </card-table>

      </card-content>
    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-2">Cancelar</button>
      <v-button :run="marcarAtosImpressos" class="btn-outline-primary ml-auto">Marcar como impresso</v-button>
      <v-button :run="run" class="btn-outline-primary ml-2">Visualizar</v-button>
    </template>

  </modal>
</template>

<script>
import LayoutImpressaoBusiness from "@/business/crud/LayoutImpressaoBusiness.js";
import FrontBusiness from "@/business/FrontBusiness";
import AtoBusiness from "@/business/protocolo/AtoBusiness.js";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import Modal from "@/components/Modal";
import Ajuda from "@/components/Checklist/Ajuda.vue";

export default {
    name: "ImprimirFichaLote",
    components: {CardTable, CardContent, Card, Modal},

    props: ['livro'],

    async mounted() {

      let promises;
      if (this.livro == 'REGISTRO_AUXILIAR') {
        promises = [/*LayoutImpressaoBusiness.listByTipo('REGISTRO_AUXILIAR_V2'),*/ LayoutImpressaoBusiness.listByTipo('REGISTRO_AUXILIAR_V3')];
      } else {
        promises = [/*LayoutImpressaoBusiness.listByTipo('MATRICULA_V2'),*/ LayoutImpressaoBusiness.listByTipo('MATRICULA_V3')];
      }

      let r = await Promise.all(promises);
      this.layouts = r[0];
      this.$set(this.form, 'layout', this.layouts?.[0]?.id);
      this.aplicarDpiLayout();

    },

    modal: {
      // width: 400,
      escapable: true
    },

    data() {
      return {
        loading: false,

        layouts: [],
        dpiDigitalizacao: this.$root.enums?.EnumDpiDigitalizacao,
        dpiDigitalizacaoLayout: 'MEDIO',
        fichas:[],
        template: '',
        form: {

          layout: null,
          dpiDigitalizacao: 'MEDIO',
          indicadores:[],

          completo: true,
          parcial: false,
          linha : false,
          linhaEncerramento: false,
          incluirTextoLegado: false,
          quantidadeLinha: 1,

        },

        textosAjuda: {
          dpiDigitalizacao: LayoutImpressaoBusiness.textoAjudaQualidadeImagem()
        }

      }
    },

    computed: {
      layoutSelecionado() {
        return this.layouts.find(e => e.id === this.form.layout);
      },
    },

    watch: {
      'form.layout'() {
        this.aplicarDpiLayout();
      },
    },

    methods: {

      aplicarDpiLayout() {
        const dpi = this.layoutSelecionado?.dpiDigitalizacao || 'MEDIO';
        this.$set(this, 'dpiDigitalizacaoLayout', dpi);
        this.$set(this.form, 'dpiDigitalizacao', dpi);
      },

      exibirAjuda(ajuda) {
        FrontBusiness.openModal(Ajuda, {ajuda});
      },

      close(response) {
        FrontBusiness.closeModal(response);
      },

      async run() {

        try{

          if(!this.fichas?.length){
            return;
          }

          await LayoutImpressaoBusiness.confirmarDpiAlto(this.form.dpiDigitalizacao, this.dpiDigitalizacaoLayout);

          const dto = {
             incluirTextoLegado : this.form.incluirTextoLegado,
             impressaoCompleta : this.form.completo,
             dpiDigitalizacao: this.form.dpiDigitalizacao,
             livro : this.form.livro,
             ids: this.fichas.map(e => e.id)
          }

          console.debug('config', dto);

          let pdf = await LayoutImpressaoBusiness.imprimirFichaLote(this.livro, this.form.layout, dto);
          FrontBusiness.downloadFile(pdf, 'impressao.pdf');

        }catch (e){
          console.error(e);
        }
      },

      async marcarAtosImpressos() {

        try{
          if(!this.fichas?.length){
            return;
          }

          const ids = this.fichas.map(e => e.id);

          await AtoBusiness.marcarImpressosLote(this.livro, true,ids)
          FrontBusiness.showSuccess('', 'Atos marcados como impressos com sucesso!');
        }catch (e){
          console.error(e);
        }

      },

      nomearFicha: FrontBusiness.nomearFicha,

      removerFichas(idx) {
        this.$nextTick(() => {
          this.fichas.splice(idx, 1);
        });
      },

      selecionarFichas(fichas) {
        this.$nextTick(() => {
          fichas?.forEach((ficha) => {
            if (ficha && !this.fichas.find(e => e.id === ficha.id && e.livro === ficha.livro)) {
              this.fichas.push(ficha);
            }
          });
        });
      },


    }
  }
</script>
